<template>
  <div>
    <subComponents ref="showSelectData"></subComponents>
    <el-dialog :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus" :append-to-body="true">
      <el-form :model="sendDataInfo" v-if="formData" label-width="120px">
        <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" :rules="formOneValue.isRequired == 1 ? [{required: true, message: '不能为空', trigger: ['blur', 'change']}] : []"
          v-for="(formOneValue,formOneKey) in formData.jurconfigform" :key="formOneKey">
          <!-- 系统字段 -->
          <div v-if="formOneValue.isReserved == 0">
            <div v-if="formOneValue.entityField == 'conaFname'">
              <label for="certificate_file">
                <input type="file" ref="clearFile" style="display: none;" id="certificate_file" @change="fileUpload($event)">
                <a style="padding:  .4rem 1rem;background-color: #409EFF;color: #FFFFFF;border-radius: 3px;display: inline-block;font-size: 12px;">
                  {{sendDataInfo[formOneValue.entityField] =='' ? '选择附件' : sendDataInfo[formOneValue.entityField]}}
                </a>
              </label>
            </div>
            <!-- 附件地址 -->
            <div v-else-if="formOneValue.entityField == 'conaFpath'">
              {{sendDataInfo[formOneValue.entityField]}}
            </div>
            <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>

          </div>
          <!-- 扩展字段 -->
          <div v-if="formOneValue.isReserved == 1">

            <!-- 自填 -->
            <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength">

            </el-input>
            <!-- 选择数据来源 -->
            <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-else :maxlength="$store.state.inputLength" @focus="$refs['showSelectData'].openBox(formOneValue.dsmName,formOneValue.entityField,formOneValue.dsmField)">
            </el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dataActionBox.showStatus = false">取 消</el-button>
        <el-button type="primary" @click="sendDataAction()">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  name: 'contractFile',
  // props:['formData'],
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: 'ltr' || 'rtl',
        boxTitle: '新增' || '编辑',
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        "conaFname": "",
        "conaFpath": "",
        "conaFtype": 0,
        "conaRemark": "",
        "conaReserves1": "",
        "conaReserves2": "",
        "conaReserves3": "",
        "conaReserves4": "",
        "conmId": 0,
        conaId: '',
      },
      formData: {},

    };
  },
  //监听属性 类似于data概念
  computed: {
  },
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    async fileUpload(event) {
      var file = event.target.files[0];
      var requestData = {
        file: file
      }

      // console.log(requestData)
      const loading = this.$loading({
        lock: true,
        text: '文件上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let saveData = await this.$http.uploadFile(requestData, true)
      if (saveData.status == 200) {
        this.$message({
          type: 'success',
          message: '文件上传成功'
        });
        loading.close();
        this.sendDataInfo.conaFname = saveData.result.fileName
        this.sendDataInfo.conaFpath = saveData.result.localPath
        this.sendDataInfo.conaFtype = saveData.result.type

        this.$refs.clearFile.value = null;
      } else {
        loading.close();
        this.$message({
          type: 'error',
          message: saveData.message
        });
      }

    },
    isShowData(name, value) {
      var dataInfo = sessionStorage.getItem('selectBusinessGoodsEntryInfo')
      if (dataInfo) {
        dataInfo = JSON.parse(dataInfo)
        this.sendDataInfo.bgmId = dataInfo.bgmId
        this.sendDataInfo.bgmName = dataInfo.bgmName
        this.sendDataInfo.bgmPlaceorigin = dataInfo.bgmPlaceorigin
        this.sendDataInfo.bgmSpecifications = dataInfo.bgmSpecifications
        this.sendDataInfo.bgmManufacturer = dataInfo.bgmManufacturer
      }

    },
    initActionBox() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = ''
      }

      this.sendDataInfo.condNumber = 0
      this.sendDataInfo.condTaxprice = 0
      this.sendDataInfo.condTaxmoney = 0

      this.dataActionBox.actionType = 0
      this.dataActionBox.showStatus = false
    },
    openBox(cate, formData, mainId, oldData = '') {
      this.formData = formData
      this.initActionBox()
      this.sendDataInfo.conmId = mainId
      if (cate == 0) {
        this.dataActionBox.boxTitle = '新增信息'
        this.dataActionBox.openMode = 'ltr'
      } else {
        this.dataActionBox.boxTitle = '编辑信息'
        this.dataActionBox.openMode = 'rtl'
        for (let key in oldData) {
          this.sendDataInfo[key] = oldData[key]
        }

      }
      this.dataActionBox.actionType = cate
      this.dataActionBox.showStatus = true

    },



    // 新增或修改
    async sendDataAction() {
      if (this.sendDataInfo.conaFname == '') {
        this.$message({
          message: '请上传附件',
          type: 'error'
        });
        return false
      }
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
      if (this.dataActionBox.actionType == 0) {
        var responseData = await this.$http.addContractFile(sendData)
      } else {
        var responseData = await this.$http.editContractFile(sendData)
      }
      if (responseData.status == 200) {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.initActionBox()
        this.$parent.getDataList()



      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeCreate() {
  }, //生命周期 - 创建之前
  beforeMount() {
  }, //生命周期 - 挂载之前
  beforeUpdate() {
  }, //生命周期 - 更新之前
  updated() {
  }, //生命周期 - 更新之后
  beforeDestroy() {
  }, //生命周期 - 销毁之前
  destroyed() {
  }, //生命周期 - 销毁完成
  activated() {
  }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
</style>